import { useQuery, useMutation } from "@tanstack/react-query";
import { fetchAllBanks } from "services/bank";

export const useAllBanks = (filters = {}) => {
  const query = useQuery({
    queryKey: ["all-banks", filters],
    queryFn: () => fetchAllBanks(filters),
  });
  return query;
};
